import type { ServiceEntity } from "../model";

import { groupBy } from "~/shared/record";

function groupSelectedServices(
  services: ServiceEntity.Schema[] = [],
  selectedServices: (Pick<ServiceEntity.Schema, "id"> & {
    count: number;
  })[] = [],
) {
  return groupBy(
    services
      .map((service) => {
        const { count = 0 } =
          selectedServices.find((selectedService) => selectedService.id === service.id) ?? {};
        return { ...service, count };
      })
      .filter(({ count }) => count > 0),
    ({ category: { id } }) => id,
  );
}

export { groupSelectedServices };
